import { Typography } from "@mui/material";
import React from "react";
import preval from 'preval.macro';
import moment from "moment";
import { useStyles } from "./VersionIndicator.styles";


const buildDateString: string = preval`module.exports = (new Date()).toISOString();`

const dateTimeStamp = moment(buildDateString).format('ddd D MMM, hh:mm')

const version = process.env.REACT_APP_VERSION

export const VersionIndicator: React.FC = () => {
    const classes = useStyles();

    if (!version) {
        return null
    }

    return (
        <aside className={classes.container}>
            <Typography
                className={classes.version} variant="overline"
                style={{ textTransform: 'none' }}
            >
                V{version}<br />
                <Typography
                    className={classes.date} variant="overline"
                    style={{ textTransform: 'none' }}
                >
                    {dateTimeStamp}<br />
                </Typography>
            </Typography>

        </aside>
    );
};
